import { PartialTranslation } from '../translations';

export const hi: PartialTranslation = {
  newChat: 'नई चैट',
  search: 'खोजें',
  user: 'उपयोगकर्ता',
  settings: 'सेटिंग्स',
  language: 'भाषा',
  getHelp: 'सहायता प्राप्त करें',
  viewAllPlans: 'सभी योजनाएं देखें',
  learnMore: 'और जानें',
  logOut: 'लॉग आउट',
  chooseLanguage: 'भाषा चुनें',
  chooseYourPreferredLanguage: 'अपनी पसंदीदा भाषा चुनें',
  searchLanguages: 'भाषाएं खोजें...',
  autoDetect: 'स्वचालित पहचान',
  noLanguagesFound: 'कोई भाषा नहीं मिली',
  askAnything: 'कुछ भी पूछें',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'व्यक्तिगत',
  freePlan: 'मुफ्त योजना',
  current: 'वर्तमान',
  close: 'बंद करें',
  archive: 'संग्रहीत करें',
  delete: 'हटाएं',
  confirmDelete: 'क्या आप वाकई इस चैट को हटाना चाहते हैं?',
  confirmArchive: 'क्या आप वाकई इस चैट को संग्रहीत करना चाहते हैं?',
  deleteCannotUndo: 'यह क्रिया को वापस नहीं किया जा सकता।',
  archiveCanFind: 'संग्रहीत करने के बाद आप इसे संग्रह सूची में पा सकते हैं।',
  
  // 资源面板
  resources: 'संसाधन',
  addResource: 'संसाधन जोड़ें',
  deleteResource: 'संसाधन हटाएं',
  noMatchingResourcesFound: 'कोई मेल खाने वाले संसाधन नहीं मिले',
  noResourcesAvailable: 'कोई संसाधन उपलब्ध नहीं',
  hideResources: 'संसाधन छुपाएं',
  showResources: 'संसाधन दिखाएं',
  
  // 聊天输入框
  typeMessage: 'एक संदेश टाइप करें...',
  thinkingOptions: 'विचार विकल्प',
  deleteFile: 'फ़ाइल हटाएं',
  clearSelection: 'चयन साफ़ करें',
  addAttachment: 'संलग्नक जोड़ें',
  sendMessage: 'संदेश भेजें',
  
  // 思考模式选项
  deepInsight: 'गहरी अंतर्दृष्टि · सतही विश्लेषण',
  deepInsightDesc: 'मुख्य बिंदुओं की त्वरित समझ',
  deepExploration: 'गहरी खोज · व्यापक विश्लेषण',
  deepExplorationDesc: 'बहुआयामी गहन अनुसंधान',
  deepDeconstruction: 'गहरा विखंडन · व्यवस्थित तर्क',
  deepDeconstructionDesc: 'परत-दर-परत प्रगतिशील विश्लेषण',
  
  // 写作模式选项
  contractReview: 'अनुबंध समीक्षा · जोखिम पहचान',
  contractReviewDesc: 'खंड विश्लेषण और अनुपालन जांच',
  textPolish: 'पाठ परिष्करण · पेशेवर अभिव्यक्ति',
  textPolishDesc: 'भाषा अनुकूलन और संरचना समायोजन',
  legalDocuments: 'कानूनी दस्तावेज़ · मानक मसौदा',
  legalDocumentsDesc: 'पेशेवर कानूनी दस्तावेज़ लेखन',

  // 认证和隐私翻译
  login: 'लॉग इन करें',
  register: 'रजिस्टर करें',
  welcomeBack: 'LawHelper में आपका स्वागत है',
  loginSubtitle: 'आपका AI कानूनी अनुसंधान सहायक',
  continueWithGoogle: 'Google के साथ जारी रखें',
  continueWithMicrosoft: 'Microsoft के साथ जारी रखें',
  continueWithWeChat: 'WeChat के साथ जारी रखें',
  orContinueWith: 'या इसके साथ जारी रखें',
  emailTab: 'ईमेल',
  phoneTab: 'फोन',
  emailPlaceholder: 'अपना ईमेल दर्ज करें',
  phonePlaceholder: 'फोन नंबर दर्ज करें',
  codePlaceholder: '6 अंकों का कोड दर्ज करें',
  sending: 'भेजा जा रहा है...',
  verifying: 'सत्यापित किया जा रहा है...',
  verify: 'सत्यापित करें',
  sendMagicLink: 'मैजिक लिंक भेजें',
  getVerificationCode: 'कोड प्राप्त करें',
  resendCode: 'कोड पुनः भेजें',
  resendIn: 'पुनः भेजें',
  magicLinkSent: 'मैजिक लिंक आपके ईमेल पर भेजा गया',
  magicLinkHint: 'हम आपके ईमेल पर एक सुरक्षित लिंक भेजेंगे',
  otpSent: 'सत्यापन कोड भेजा गया',
  agreeToTerms: 'जारी रखकर, आप हमारी सहमति देते हैं',
  privacyPolicy: 'गोपनीयता नीति',
  termsOfService: 'सेवा की शर्तें',
  and: 'और',
  privacyTitle: 'आपकी गोपनीयता महत्वपूर्ण है',
  privacyIntro: 'हम आपको सर्वोत्तम अनुभव प्रदान करने के लिए कुकीज़ और समान तकनीकों का उपयोग करते हैं।',
  essentialCookies: 'आवश्यक कुकीज़',
  essentialDesc: 'वेबसाइट के कार्य के लिए आवश्यक',
  analyticsCookies: 'एनालिटिक्स कुकीज़',
  analyticsDesc: 'हमारी सेवा में सुधार करने में मदद करें',
  marketingCookies: 'मार्केटिंग कुकीज़',
  marketingDesc: 'व्यक्तिगत सामग्री के लिए उपयोग किया जाता है',
  acceptAll: 'सभी स्वीकार करें',
  essentialOnly: 'केवल आवश्यक',
  customize: 'कस्टमाइज़ करें',
  savePreferences: 'प्राथमिकताएं सहेजें',
  back: 'वापस',
  readPrivacyPolicy: 'हमारी गोपनीयता नीति पढ़ें',
  cookiePolicy: 'कुकी नीति',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI समीक्षा',
  aiDraft: 'AI ड्राफ्ट',
  smartAssistant: 'टेम्पलेट',

  // 知识库搜索
  enableKnowledgeSearch: 'खोज सक्षम करें',
  knowledgeSearchDesc: 'AI आपके दस्तावेजों में खोजता है',
  clickToDisable: 'अक्षम करें',
  clickToEnable: 'सक्षम करें',

  // Landing page translations
  tagline: 'AI-संचालित कानूनी बुद्धिमत्ता',
  heroTitle1: 'Legal AI',
  heroTitle2: 'सरल।',
  jurisdictionsLabel: 'क्षेत्र',
  accuracyLabel: 'सटीकता',
  fasterLabel: 'तेज',
  availableLabel: 'उपलब्ध',
  platformCapabilities: 'क्षमताएं',
  testimonialQuote: '"LawHelper ने हमारा काम बदल दिया।"',
  testimonialAuthor: 'पेशेवर',
  testimonialPosition: 'भागीदार',
  viewPricing: 'मूल्य',
  footerPricing: 'मूल्य',
  footerPrivacy: 'गोपनीयता',
  footerTerms: 'शर्तें',
  footerContact: 'संपर्क',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'संसाधन पैनल बंद करें',
  uploading: '%{fileName} अपलोड हो रहा है...',
  processing: '%{fileName} प्रोसेस हो रहा है...',
  uploadSuccess: '✓ %{fileName} अपलोड हो गया',
  uploadError: '✗ अपलोड विफल: %{error}',
  quickAnswer: 'त्वरित उत्तर',
  quickAnswerDesc: 'सरल प्रश्नों का त्वरित उत्तर',
  cancelRequest: 'रद्द करें',
  library: 'लाइब्रेरी',
  filterAll: 'सभी',
  filterChat: 'चैट',
  filterReview: 'समीक्षा',
  filterDraft: 'ड्राफ्ट',
  filterTemplate: 'टेम्पलेट',
  filterForm: 'फॉर्म',
  thinking: 'सोच रहा है...',
  thinkingProcess: 'विचार प्रक्रिया',
  analyzingLegalLogic: 'कानूनी तर्क का विश्लेषण...',
  lawhelperThinking: 'Lawhelper सोच रहा है...',
  serviceError: 'सेवा त्रुटि',
  uploaded: 'अपलोड किया गया',
  settingsGeneral: 'सामान्य',
  settingsNotifications: 'सूचनाएँ',
  settingsAppearance: 'दिखावट',
  settingsProfile: 'प्रोफ़ाइल',
  settingsResponseNotifications: 'प्रतिक्रिया सूचनाएँ',
  settingsResponseNotificationsDesc: 'AI प्रतिक्रिया पूर्ण होने पर सूचना',
  settingsColorMode: 'रंग मोड',
  settingsLight: 'हल्का',
  settingsDark: 'गहरा',
  settingsSystem: 'सिस्टम',
  about: 'के बारे में',
  reviewTitle: 'दस्तावेज़ समीक्षा',
  exitReview: 'समीक्षा से बाहर निकलें',
  uploadPrompt: 'समीक्षा के लिए PDF अपलोड करें',
  uploadButton: 'फ़ाइल चुनें',
  startChatConfig: '"इस दस्तावेज़ की समीक्षा करें" टाइप करें',
  reviewPlaceholder: 'संदेश टाइप करें...',
  analyzing: 'समीक्षा हो रही है...',
  reviewComplete: 'समीक्षा पूर्ण',
  issuesFound: '%{count} समस्याएँ मिलीं',
  draftTitle: 'कानूनी दस्तावेज़ तैयार करना',
  draftPlaceholder: 'यहाँ संपादित करें या AI से कहें...',
  analyzingTemplate: 'टेम्पलेट %{name} का विश्लेषण...',
  templateAnalyzed: '✅ टेम्पलेट %{name} का विश्लेषण पूर्ण!',
  templateAnalysisPrompt: 'प्रमुख खंडों का विश्लेषण करें',
  parsingFailed: '⚠️ फ़ाइल का विश्लेषण विफल।',
  generating: 'जनरेट हो रहा है...',
  generatedSuccess: '✅ दस्तावेज़ तैयार हो गया!',
  drafterWelcome: 'AI दस्तावेज़ सहायक में आपका स्वागत है',
  drafterYouCan: 'आप कर सकते हैं:',
  drafterUploadTemplate: 'AI विश्लेषण के लिए टेम्पलेट अपलोड करें',
  drafterDescribeNeeds: 'दस्तावेज़ आवश्यकताओं का वर्णन करें',
  drafterLetAiHelp: 'AI अनुबंध, समझौते आदि तैयार करने में मदद करता है',
  drafterExamples: 'उदाहरण:',
  drafterExampleRental: '"किराया अनुबंध तैयार करें"',
  drafterExampleLabor: '"श्रम अनुबंध भरें"',
  drafterInputPlaceholder: 'अपनी आवश्यकताओं का वर्णन करें...',
  drafterThinking: 'सोच रहा है...',
  drafterHistoryTitle: 'इतिहास',
  drafterNoHistory: 'कोई इतिहास नहीं',
  drafterNewChat: 'नई चैट',
  drafterHistory: 'इतिहास',
  drafterRemoveAttachment: 'अनुलग्नक हटाएँ',
  drafterLineHeight: 'पंक्ति ऊँचाई',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Word (.docx) में निर्यात',
  drafterExportPdf: 'PDF में निर्यात',
  drafterSave: 'दस्तावेज़ सहेजें',
  drafterDownload: 'दस्तावेज़ डाउनलोड करें',
  drafterUndo: 'पूर्ववत',
  drafterRedo: 'पुनः करें',
  drafterBold: 'बोल्ड',
  drafterItalic: 'इटैलिक',
  drafterStrike: 'स्ट्राइकथ्रू',
  drafterUnderline: 'रेखांकित',
  drafterHighlight: 'हाइलाइट',
  drafterLink: 'लिंक डालें',
  drafterAlignLeft: 'बाएँ संरेखित',
  drafterAlignCenter: 'केंद्र में',
  drafterAlignRight: 'दाएँ संरेखित',
  drafterAlignJustify: 'दोनों ओर',
  drafterList: 'सूची',
  drafterBulletList: 'बुलेट सूची',
  drafterOrderedList: 'क्रमांकित सूची',
  drafterTaskList: 'कार्य सूची',
  drafterOpenResource: 'संसाधन पैनल खोलें',
  drafterStopGeneration: 'जनरेशन रोकें',
  drafterAgentMode: 'एजेंट मोड सक्रिय',
  drafterAgentModeOn: 'एजेंट मोड सक्रिय',
  drafterAgentModeOff: 'सामान्य मोड',
  drafterUploadAttachment: 'अनुलग्नक अपलोड करें',
  drafterExit: 'बाहर निकलें',
  drafterConfirm: 'पुष्टि करें',
  drafterOpenLink: 'लिंक खोलें',
  drafterDeleteLink: 'लिंक हटाएँ',
  drafterQuote: 'उद्धरण',
  workflowTitle: 'AI कार्यप्रवाह',
  workflowRunning: 'चल रहा है...',
  workflowReady: 'तैयार',
  workflowCompleted: 'पूर्ण',
  workflowStartFailed: 'कार्यप्रवाह शुरू करने में विफल',
  workflowExecutionFailed: 'कार्यप्रवाह निष्पादन विफल',
  workflowInterrupted: 'कार्यप्रवाह बाधित',
  workflowProcessing: 'प्रोसेसिंग...',
  workflowStepsCompleted: 'चरण पूर्ण',
  workflowStepsTotal: 'कार्यप्रवाह पूर्ण (%{count} चरण)',
  acceptChanges: 'परिवर्तन स्वीकार करें',
  rejectChanges: 'परिवर्तन अस्वीकार करें',
  changesAccepted: 'परिवर्तन स्वीकृत',
  changesRejected: 'परिवर्तन अस्वीकृत',
  stopWorkflow: 'रोकें',
  restartWorkflow: 'पुनः आरंभ',
  startDrafting: 'ड्राफ्टिंग शुरू करें',
  interrupt: 'रोकें',
  documentSubject: 'दस्तावेज़ का विषय *',
  documentType: 'दस्तावेज़ का प्रकार',
  jurisdiction: 'क्षेत्राधिकार',
  specialRequirements: 'विशेष आवश्यकताएँ (वैकल्पिक)',
  clickStartDrafting: '"ड्राफ्टिंग शुरू करें" पर क्लिक करें',
  docTypeContract: 'अनुबंध',
  docTypeAgreement: 'समझौता',
  docTypeNotice: 'सूचना',
  docTypeLetter: 'पत्र',
  docTypePetition: 'याचिका',
  docTypeWill: 'वसीयत',
  docTypePowerOfAttorney: 'मुख्तारनामा',
  countryChina: 'चीन',
  countryUSA: 'संयुक्त राज्य अमेरिका',
  countryGermany: 'जर्मनी',
  countryJapan: 'जापान',
  countryFrance: 'फ्रांस',
  countryUK: 'यूनाइटेड किंगडम',
  citationVerified: 'सत्यापित',
  citationUnverified: 'असत्यापित',
  imageLoadFailed: 'छवि लोड करने में विफल',
  smartDocTitle: 'स्मार्ट दस्तावेज़ सहायक',
  smartDocChatTitle: 'AI दस्तावेज़ सहायक',
  smartDocDropPrompt: 'PDF फ़ाइल यहाँ छोड़ें',
  smartDocSelectFile: 'फ़ाइल चुनें',
  smartDocOr: 'या',
  smartDocWelcomeTitle: 'AI दस्तावेज़ सहायक में स्वागत है',
  smartDocWelcomeYouCan: 'आप कर सकते हैं:',
  smartDocUploadForAI: 'टेम्पलेट अपलोड करें',
  smartDocDescribeDoc: 'आवश्यकताओं का वर्णन करें',
  smartDocLetAIDraft: 'AI अनुबंधों में मदद करता है',
  smartDocExamples: 'उदाहरण:',
  smartDocExampleRental: '"किराया अनुबंध तैयार करें"',
  smartDocExampleLabor: '"श्रम अनुबंध भरें"',
  smartDocInputPlaceholder: 'आवश्यकताओं का वर्णन करें...',
  smartDocRemoveAttachment: 'अनुलग्नक हटाएँ',
  smartDocOpenResources: 'संसाधन खोलें',
  smartDocExit: 'बाहर निकलें',
  reviewStartFailed: 'समीक्षा शुरू करने में विफल',
  reviewFailed: 'समीक्षा विफल',
  reviewFoundIssues: 'समीक्षा पूर्ण, %{count} समस्याएँ।',
  cannotReadStream: 'प्रतिक्रिया स्ट्रीम पढ़ने में असमर्थ',
  parseEventFailed: 'इवेंट विश्लेषण विफल',
  errorPrefix: 'त्रुटि',
  unknownError: 'अज्ञात त्रुटि',
  file: 'फ़ाइल',
  loading: 'लोड हो रहा है...',
  localFolders: 'स्थानीय फ़ोल्डर',
  selectLocalFolder: 'स्थानीय फ़ोल्डर चुनें',
  reselectFolder: 'फ़ोल्डर बदलें',
  addToContext: 'चैट में जोड़ें',
  saveFile: 'सहेजें',
  renameFile: 'नाम बदलें',
  fileSaved: 'फ़ाइल सहेजी गई',
  fileRenamed: 'फ़ाइल का नाम %{name} रखा गया',
  browserNotSupported: 'आपका ब्राउज़र फ़ोल्डर एक्सेस का समर्थन नहीं करता',
  noFolderSelected: 'फ़ाइलें ब्राउज़ करने के लिए फ़ोल्डर चुनें',
  scanningFolder: 'फ़ोल्डर स्कैन हो रहा है...',
  selectFileToPreview: 'प्रीव्यू के लिए फ़ाइल चुनें',
  aiAnalyze: 'AI विश्लेषण',
};
